import React, {Component, Fragment, h} from "preact";
import {Modal, ModalLink} from "../../_common/components/modal";
import {RadioCheckbox} from "../../_common/forms/components/components";
import {C, CF, E, FR, RE} from "../../_common/layout";
import {t} from "../../_i18n";
//import {replaceHash} from "../../_common/common";
import {Link} from "react-router-dom";
import {showErrorClosed} from "../validateOfferEdit";
import Badge from "../../_common/components/Badge";



export class AcademicProgramsSelector extends Component<any, any>{

    remove(id:any){
        const {onChange, value} = this.props.input;
        onChange(value.filter((val:any)=>val!=id))
    }

    add(id:any){
        const {onChange, value} = this.props.input;
        onChange([...value, id]);
    }

    componentDidMount() {
        const arraySave: any[] = [];
        this.props.formative_families_kn.map(({programs, name}: any) => {
            arraySave.push({family_name: name})
            return this.props.academic_programs_kn.map(({key, name}: any) => {
              return programs.split(',').filter((id: any) => {
                 if(id == key) {
                    arraySave.push({program_id: key, program_names: name})
                 }
              })
            })
        })
        this.setState({ciclos_categorizados: arraySave})
    }


    render({academic_programs, academic_programs_kn, formative_families_kn, input:{value}, meta}:any){

        if(!academic_programs || !academic_programs_kn || !formative_families_kn) return null;

        return <p>
            <FR >
                {value.map((id:string)=><Fragment>
                    <E key={id}>
                        <Badge type='info' className='light'>
                            <span>
                                {academic_programs[id]}
                                <a className="cursor-pointer m-l-half" onClick={()=>this.remove(id)}>x</a>
                            </span>
                        </Badge>
                    </E>
                </Fragment>)}
            </FR>
            <br/>
            <ModalLink id="modalAcademicPrograms"><span className='cursor-pointer m-top text-primary font-18'>+ <span className='t-underline'>Añadir ciclos</span></span></ModalLink>

            <Modal id="modalAcademicPrograms" title={t('Selecciona ciclos')} className="md-no-fullscreen">
                <hr className="separator-xxs"></hr>
                <div className="in-modal-scroll">
                    {this.state.ciclos_categorizados ?
                    this.state.ciclos_categorizados.map(({program_id, program_names, family_name}: any) => {
                        return family_name ? <h3 className="m-top m-bottom">{family_name}</h3>
                            : <RadioCheckbox type="checkbox" defaultValue={value.includes(program_id)} label={program_names} onChange={(checked:boolean)=>checked?this.add(program_id):this.remove(program_id)}/>
                    }) : ''}
                </div>
                <hr className="separator-xxs"></hr>
                <FR className="t-left f-left">
                    <E className='sm-col-20 col-100'>
                        <button type="button" className="btn btn-primary" onClick={()=>history.back()}>Aceptar</button>
                    </E>
                </FR>
            </Modal>

            {(showErrorClosed(meta)) && <div className='m-top font-18 font-color-red'>{t('Por favor, indica un ciclo formativo como mínimo.')}</div>}
        </p>
    }
}
